import dayjs from "dayjs";
import { useT } from "~/util/Lang";

export function formatDate(date: string | Date) {
  const t = useT();
  return t({
    en: dayjs(date).format("YYYY/MM/DD HH:mm"),
    ru: dayjs(date).format("DD.MM.YYYY HH:mm"),
  });
}
